<template>
  <div class="CTA">
    <a class="button xl" :href="getUrl('register', 'cta')">{{ $t(btnText) }}</a>
  </div>
</template>

<script>
import BaseComponent from './BaseComponent'

export default {
  name: 'GetCTA',
  mixins: [BaseComponent],
  props: {
    btnText: {
      type: String,
      default: 'startFreeTrial'
    }
  }
}
</script>

<style lang="scss" scoped></style>
